import settings from '../settings.js'

const $inject = ['$scope', 'common']

function LogCtrl(scope, common) {
    scope.items = [];
    scope.preview = {
        show: false,
        content: '',
        style: {
            position: 'fixed',
            left: ((window.innerWidth / 2) - 150) + 'px',
            top: ((window.innerHeight / 2) - 150) + 'px',
            width: '300px',
            height: '300px',
            'z-index': 2,
            background: '#fdfdfd',
            'box-shadow': '0 6px 24px 0px #666',
            padding: '15px',
            'font-size': '10px'
        },
        setContent(content, ev) {
            this.content = content;
            this.show = true;
        }
    };

    scope.$on("$ionicView.enter", (event, data) => {
        scope.items = common.getLog();
    });
}

LogCtrl.$inject = $inject

export default LogCtrl